import React, {useState, useEffect} from 'react'
import {usePasswordAndConfirmFields} from "../hooks";
import {useApi} from "../ApiSession";
import ComplexInput from "../widgets/ComplexInput";
import {useNavigate} from "react-router-dom";
import {DefaultButton} from "../widgets/Buttons";

const Grid131313 = ({children}) =>
    <div className="flex flex-row">
        <div className="basis-1/3"></div>
        <div className="basis-1/3">{children}</div>
        <div className="basis-1/3"></div>
    </div>


export default () => {

    const [email, setEmail] = useState('')
    //const [userId, setUserId] = useState(null)
    const [resetGuid, setResetGuid] = useState(null)

    const [isExpired, setIsExpired] = useState(false)

    const navigate = useNavigate()

    const api = useApi()

    const  {
        password,
        setPassword,
        passwordConfirm,
        setPasswordConfirm,
        warnFieldsDiffer,
        problemList,
        passwordStrengthWeak,
        canReset
    } = usePasswordAndConfirmFields(8)

    useEffect(() => {

        const guid = __RESET_INFO__[0]

        if(guid === "EXPIRED") {
            setIsExpired(true)
        }
        setResetGuid(__RESET_INFO__[0])
        setEmail(__RESET_INFO__[1])
    }, []);


    const putResetPassword = () => {
        api.resetPassword(password, resetGuid).then(res => {
            navigate(`/login`)
        })
    }

    if(isExpired) {
        return <Grid131313><h1>Lien expiré</h1></Grid131313>
    }

    return <div>

        <Grid131313>
            <div>
                <p className="mb-6 text-lg font-normal text-gray-500 lg:text-xl sm:px-16 xl:px-48 dark:text-gray-400">
                    Choose Password
                </p>

                <div>
                    <div className="mb-5">
                        <label htmlFor="email" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                            Email</label>
                        <input type="email"
                               className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                               value={email}
                               onChange={() => {
                               }}
                               disabled={true}
                        />
                    </div>
                    <div className="mb-5">
                        <ComplexInput
                            label={"Password"}
                            value={password}
                            type={"password"}
                            onChange={e => setPassword(e.target.value)}
                            errorMessage={passwordStrengthWeak ? <ul>
                                {problemList.map(m => <li key={m}>{m}</li>)}
                            </ul> : null}
                        />
                    </div>
                    <div className="mb-5">
                        <ComplexInput
                            label={"Confirm password"}
                            value={passwordConfirm}
                            type={"password"}
                            onChange={e => setPasswordConfirm(e.target.value)}
                            errorMessage={warnFieldsDiffer ? <span>
                                differs from password
                            </span>: null
                        }
                        />
                    </div>
                    <DefaultButton
                        onClick={putResetPassword}
                        isDisabled={! canReset}
                        caption={"Activate account"}
                    />
                </div>
            </div>
        </Grid131313>
    </div>

}